// Translates legacy tag slugs used in old videos search query string to new database table fields for filter object
// e.g. OLD: /videos?tags=artist=the-who => NEW: /videos?lesson_artist=The Who

export const tagMapping = JSON.parse(`[
  {
    "tag_slug": "artist-the-who",
    "value": "The Who",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-the-eagles",
    "value": "The Eagles",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-chuck-berry",
    "value": "Chuck Berry",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-aerosmith",
    "value": "Aerosmith",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-buddy-holly",
    "value": "Buddy Holly",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-pink-floyd",
    "value": "Pink Floyd",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-oasis",
    "value": "Oasis",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-bruno-mars",
    "value": "Bruno Mars",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-dire-straits-mark-knopfler",
    "value": "Dire Straits/ Mark Knopfler",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-david-bowie",
    "value": "David Bowie",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-jack-johnson",
    "value": "Jack Johnson",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-green-day",
    "value": "Green Day",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-adele",
    "value": "Adele",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-jazon-mraz",
    "value": "Jazon Mraz",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-led-zeppelin",
    "value": "Led Zeppelin",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-bon-jovi",
    "value": "Bon Jovi",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-u2",
    "value": "U2",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-the-smiths",
    "value": "The Smiths",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-bob-dylan",
    "value": "Bob Dylan",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-arctic-monkeys",
    "value": "Arctic Monkeys",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-guns-n-roses",
    "value": "Guns N Roses",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-elvis-presley",
    "value": "Elvis Presley",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-john-mayer",
    "value": "John Mayer",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-jimi-hendrix",
    "value": "Jimi Hendrix",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-johnny-cash",
    "value": "Johnny Cash",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-the-black-keys",
    "value": "The Black Keys",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-status-quo",
    "value": "Status Quo",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-taylor-swift",
    "value": "Taylor Swift",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-the-beatles",
    "value": "The Beatles",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-nirvana",
    "value": "Nirvana",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-ed-sheeran",
    "value": "Ed Sheeran",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-acdc",
    "value": "AC/DC",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-bruce-springsteen",
    "value": "Bruce Springsteen",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-foo-fighters",
    "value": "Foo Fighters",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-eric-clapton",
    "value": "Eric Clapton",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-fleetwood-mac",
    "value": "Fleetwood Mac",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-bob-marley",
    "value": "Bob Marley",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-star-wars",
    "value": "Star Wars",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-queen",
    "value": "Queen",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-shawn-mendes",
    "value": "Shawn Mendes",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-radiohead",
    "value": "Radiohead",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-rolling-stones",
    "value": "Rolling Stones",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "artist-red-hot-chili-peppers",
    "value": "Red Hot Chili Peppers",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "decade-80s",
    "value": "80s",
    "key": "lesson_decade"
  },
  {
    "tag_slug": "decade-90s",
    "value": "90s",
    "key": "lesson_decade"
  },
  {
    "tag_slug": "decade-50s",
    "value": "50s and earlier",
    "key": "lesson_decade"
  },
  {
    "tag_slug": "decade-60s",
    "value": "60s",
    "key": "lesson_decade"
  },
  {
    "tag_slug": "decade-00s",
    "value": "2000s",
    "key": "lesson_decade"
  },
  {
    "tag_slug": "decade-2010s",
    "value": "2010s",
    "key": "lesson_decade"
  },
  {
    "tag_slug": "decade-70s",
    "value": "70s",
    "key": "lesson_decade"
  },
  {
    "tag_slug": "genre-blues",
    "value": "Blues",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-reggae",
    "value": "Reggae",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-grunge",
    "value": "Grunge",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-films-movies",
    "value": "Music from Film/ Movies/ TV",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-rock",
    "value": "Rock",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-indie",
    "value": "Indie",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-country",
    "value": "Country",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-alternative-rock",
    "value": "Alternative Rock",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-pop",
    "value": "Pop",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-fingerstyle",
    "value": "Fingerstyle",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-punk",
    "value": "Punk",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-folk",
    "value": "Folk",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-acoustic",
    "value": "Acoustic",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-vintage",
    "value": "Vintage",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "genre-christmas-songs",
    "value": "Christmas Songs",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "type-lesson",
    "value": "Lesson",
    "key": "lesson_category"
  },
  {
    "tag_slug": "type-song",
    "value": "Song",
    "key": "lesson_category"
  },
  {
    "tag_slug": "difficulty-beginner",
    "value": "Beginner",
    "key": "lesson_difficulty"
  },
  {
    "tag_slug": "difficulty-improver",
    "value": "Improver",
    "key": "lesson_difficulty"
  },
  {
    "tag_slug": "difficulty-intermediate",
    "value": "Intermediate",
    "key": "lesson_difficulty"
  },
  {
    "tag_slug": "blues-rock",
    "value": "Blues Rock",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "2020s-1",
    "value": "2020s",
    "key": "lesson_decade"
  },
  {
    "tag_slug": "advanced",
    "value": "Advanced",
    "key": "lesson_difficulty"
  },
  {
    "tag_slug": "acoustic-2",
    "value": "Acoustic",
    "key": "lesson_instrument"
  },
  {
    "tag_slug": "electric-1",
    "value": "Electric",
    "key": "lesson_instrument"
  },
  {
    "tag_slug": "ukulele",
    "value": "Ukulele",
    "key": "lesson_instrument"
  },
  {
    "tag_slug": "grade-1",
    "value": "Grade 1",
    "key": "lesson_grade"
  },
  {
    "tag_slug": "grade-2",
    "value": "Grade 2",
    "key": "lesson_grade"
  },
  {
    "tag_slug": "grade-3",
    "value": "Grade 3",
    "key": "lesson_grade"
  },
  {
    "tag_slug": "grade-4",
    "value": "Grade 4",
    "key": "lesson_grade"
  },
  {
    "tag_slug": "grade-5",
    "value": "Grade 5",
    "key": "lesson_grade"
  },
  {
    "tag_slug": "grade-6",
    "value": "Grade 6",
    "key": "lesson_grade"
  },
  {
    "tag_slug": "grade-7",
    "value": "Grade 7",
    "key": "lesson_grade"
  },
  {
    "tag_slug": "coldplay",
    "value": "Coldplay",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "white-stripes",
    "value": "White Stripes",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "jazz",
    "value": "Jazz",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "funk",
    "value": "Funk",
    "key": "lesson_genre"
  },
  {
    "tag_slug": "open-chords",
    "value": "Open chords",
    "key": "lesson_skill"
  },
  {
    "tag_slug": "barre-chords",
    "value": "Barre chords",
    "key": "lesson_skill"
  },
  {
    "tag_slug": "power-chords",
    "value": "Power chords",
    "key": "lesson_skill"
  },
  {
    "tag_slug": "riffs",
    "value": "Riffs",
    "key": "lesson_skill"
  },
  {
    "tag_slug": "solos-1",
    "value": "Solos",
    "key": "lesson_skill"
  },
  {
    "tag_slug": "mneskin",
    "value": "Måneskin",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "olivia-rodrigo",
    "value": "Olivia Rodrigo",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "camila-cabello",
    "value": "Camila Cabello",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "lesson-acoustic-guitar",
    "value": "Acoustic Guitar",
    "key": "lesson_instrument"
  },
  {
    "tag_slug": "lesson-electric-guitar",
    "value": "Electric Guitar",
    "key": "lesson_instrument"
  },
  {
    "tag_slug": "lesson-ukulele",
    "value": "Ukulele",
    "key": "lesson_instrument"
  },
  {
    "tag_slug": "lesson-beginner",
    "value": "Beginner",
    "key": "lesson_difficulty"
  },
  {
    "tag_slug": "lesson-improver",
    "value": "Improver",
    "key": "lesson_difficulty"
  },
  {
    "tag_slug": "lesson-intermediate",
    "value": "Intermediate",
    "key": "lesson_difficulty"
  },
  {
    "tag_slug": "lesson-advanced",
    "value": "Advanced",
    "key": "lesson_difficulty"
  },
  {
    "tag_slug": "voice",
    "value": "Voice",
    "key": "lesson_instrument"
  },
  {
    "tag_slug": "stevie-ray-vaughan",
    "value": "Stevie Ray Vaughan",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "bb-king",
    "value": "B.B. King",
    "key": "lesson_artist"
  },
  {
    "tag_slug": "top-10-5",
    "value": "\\"Top\\" lists",
    "key": "lesson_type"
  },
  {
    "tag_slug": "2-chord-song",
    "value": "2 chord song",
    "key": "lesson_type"
  },
  {
    "tag_slug": "3-chord-song",
    "value": "3 chord song",
    "key": "lesson_type"
  },
  {
    "tag_slug": "4-chord-song",
    "value": "4 chord song",
    "key": "lesson_type"
  },
  {
    "tag_slug": "5-chord-song",
    "value": "5 chord song",
    "key": "lesson_type"
  },
  {
    "tag_slug": "type-live-replay",
    "value": "Live Replay",
    "key": "lesson_category"
  },
  {
    "tag_slug": "the-darkness",
    "value": "The Darkness",
    "key": "lesson_artist"
  }
]`);
